export default [
	{
		path: "decision",
		meta: {
      helpTag: "party:decision",
    },
    component: () =>
			import(
				"../../views/general/decision"
			),
			children: [
				// {
				// 	path: "",
				// 	name: "Party.Decision",
				// 	component: () =>
				// 		import(
				// 			"../../views/party-public/decision/list"
				// 		),
				// },
				{
					path: ":hexkey/:bsi_hexkey([a-z0-9]{32})?",
					name: "Party.Decision.Details",
					component: () =>
						import(
							"../../views/general/decision/decision.vue"
						),
				},
			],
  },
];